import { useApiQuery } from '@/hooks/useApiQuery';
import { settingsKeys } from '@/lib/queryKeys';
import type { ChatbotConfig } from '@/types/settings';

// The AI chatbot config endpoint (`/api/chatbot/config`) lived on the
// now-defunct monolith. Operations / ai-operations don't expose an
// equivalent yet, so the call 404'd from every page that imports this
// hook (settings/chatbot and settings/integrations both hit it on
// mount).
//
// Return a synchronous disabled-by-default config until the chatbot
// config path is rebuilt. Both consumers already handle the disabled
// state gracefully; no network call is made.
const DISABLED_CONFIG: ChatbotConfig = {
  enabled: false,
  businessHoursOnly: false,
  collectName: false,
  collectEmail: false,
  collectPhone: false,
};

export function useChatbotConfig() {
  return useApiQuery<ChatbotConfig>({
    queryKey: settingsKeys.chatbot(),
    queryFn: () => Promise.resolve(DISABLED_CONFIG),
    showErrorToast: false,
    retry: false,
    staleTime: Infinity,
  });
}
